import {Component, Input} from "@angular/core";

@Component({
  selector: "pcg-ng-popover",
  template: require('./popover.component.html')
})
export class PopoverComponent {

    @Input()
    public text: string;

    @Input()
    public isHtml: boolean = false;
}
